import routeNames from '@enums/route-names';
import ExportFormats from '@enums/export-formats';
import store from '@/js/store';

const guardsMap = {
    [routeNames.freeGiftsView]() {
        return true;
    },
    [routeNames.rateCardView]() {
        return true;
    },
    async [routeNames.offerPresetsAdmin]() {
        await Promise.all([
            store.dispatch('offerMechanicPresets/fetchOfferMechanicPresets'),
            store.dispatch('priceTags/fetchPriceTags'),
        ]);
        return true;
    },
    [routeNames.loyaltyPointsView]() {
        return true;
    },
    [routeNames.userPermissions]() {
        return true;
    },
    [routeNames.clientSystemsTesting]() {
        return true;
    },
    [routeNames.redisBull]() {
        return true;
    },
    [routeNames.featureToggler]() {
        return true;
    },
    async [routeNames.executionErrors](to) {
        const startDate = to.query.startDate || null;
        const endDate = to.query.endDate || null;
        await store.dispatch('promotions/downloadPromotionsWithExecutionErrors', {
            params: {
                export: true,
                exportFormat: ExportFormats.excel,
                startDate,
                endDate,
            },
        });
        return true;
    },
    [routeNames.configEditorView]() {
        return true;
    },
};

export default guardsMap;
